export default function ProtectedRoute(){
    return(
        <h1>Protected Route</h1>
    )
}